export function matchTokens(text, query) {
  if (!query || !query.trim()) return true;
  const tl = (text || '').toLowerCase();
  return query.toLowerCase().trim().split(/\s+/).every(token => tl.includes(token));
}

export function matchTokensAny(fields, query) {
  if (!query || !query.trim()) return true;
  const tokens = query.toLowerCase().trim().split(/\s+/);
  const blob = fields.map(f => (f || '').toLowerCase()).join(' | ');
  return tokens.every(token => blob.includes(token));
}
